import { getRouterPathFromBrowser, toAppUrl } from "@shared/utils/url/toAppUrl";
import { AppPaths } from "./paths";
import { REDIRECT_QUERY_PARAM } from "./queryParams";

/**
 * Редиректит на страницу авторизации с сохранением текущего пути. \
 * Учитывает Vite `base` (саброут деплоя), иначе `location.assign("/auth")` уходит с `/mobile/...` на корень хоста.
 *
 * @todo(legacy): hard-навигация через `window.location.assign` — временный костыль. \
 * Нужен паттерн как в nbp: `logout` пишет transient session-loss event в store, \
 * а `SessionRedirectGate` внутри `BrowserRouter` делает `navigate` (basename бесплатно).
 */
export function redirectToAuth(): void {
    const params = new URLSearchParams();
    params.set(REDIRECT_QUERY_PARAM, getRouterPathFromBrowser());
    const authPath = `${AppPaths.AUTH}?${params.toString()}`;
    const href = toAppUrl(authPath, window);
    if (href == null) {
        return;
    }
    // TODO(legacy): заменить на store event + SessionRedirectGate / navigate (см. JSDoc).
    window.location.assign(href);
}
